import { Component } from '@angular/core';

@Component({
  selector: 'bemum-container',
  templateUrl: './container.component.html',
  styleUrls: ['./container.component.scss'],
  standalone: false,
})
export class ContainerComponent {}
